export type PlacesQueryStatus = "pending" | "completed" | "failed";

export interface PlacesQueryPrefecture {
  id: string;
  name: string;
  type?: string;
  external_id?: number;
}

export interface PlacesQueryCity {
  id: string;
  name: string;
  type?: string;
  external_id?: number;
}

export interface PlacesQuery {
  id: string;
  name: string;
  prefecture_id: string;
  city_id: string | null;
  categories: string[];
  max_results: number;
  status: PlacesQueryStatus;
  error_message: string | null;
  created_at: string;
  created_by: string;
  last_modified_at: string;
  last_modified_by: string;
  prefecture?: PlacesQueryPrefecture;
  city?: PlacesQueryCity;
  _count?: { results: number };
}

export interface PlacesQueryResult {
  id: string;
  query_id: string;
  place_id: string;
  name: string | null;
  formatted_address: string | null;
  national_phone_number: string | null;
  international_phone_number: string | null;
  google_maps_uri: string | null;
  business_status: string | null;
  website_uri: string | null;
  regular_opening_hours: { weekdayDescriptions: string[] } | null;
  rating: string | null;
  user_rating_count: number | null;
  price_level: string | null;
  created_at: string;
}

export type PlacesQueryDetail = PlacesQuery;

export interface CreatePlacesQueryPayload {
  name: string;
  prefecture_id: string;
  city_id?: string;
  categories: string[];
  max_results: number;
}

export type PlacesQuerySortField = "created_at" | "name" | "status";

export interface PlacesQuerySearchParams {
  sort?: PlacesQuerySortField;
  order?: "asc" | "desc";
  limit?: number;
  offset?: number;
  seek_total_count?: boolean;
  status?: PlacesQueryStatus;
  name?: string;
}

export interface PlacesQueryListResponse {
  data: PlacesQuery[];
  count?: number;
}

export const PLACES_QUERY_MAX_RESULTS_CEILING = 200;

export type PlacesQueryResultSortField =
  | "created_at"
  | "name"
  | "rating"
  | "user_rating_count";

export type PlacesQueryResultBusinessStatus =
  | "OPERATIONAL"
  | "CLOSED_TEMPORARILY"
  | "CLOSED_PERMANENTLY";

export type PlacesQueryResultPriceLevel =
  | "PRICE_LEVEL_FREE"
  | "PRICE_LEVEL_INEXPENSIVE"
  | "PRICE_LEVEL_MODERATE"
  | "PRICE_LEVEL_EXPENSIVE"
  | "PRICE_LEVEL_VERY_EXPENSIVE";

export interface PlacesQueryResultsSearchParams {
  sort?: PlacesQueryResultSortField;
  order?: "asc" | "desc";
  limit?: number;
  offset?: number;
  seek_total_count?: boolean;
  name?: string;
  business_status?: PlacesQueryResultBusinessStatus;
  price_level?: PlacesQueryResultPriceLevel;
  min_rating?: number;
}

export interface PlacesQueryResultsListResponse {
  data: PlacesQueryResult[];
  count?: number;
}
